/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns the first activation date in milliseconds for the tenant.
 *
 * @agent-skills: tenant-context
 */
export const useFirstActivationDateMs = (): number | null => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.firstActivationDateMs != null
		? tenantContext.firstActivationDateMs
		: null;
};
